<template>
  <div :class="homeClass" style="height: 100%;flex:1">
    <div class="header-container">
      <HeaderSegnala />
    </div>
    <vl-map
      :controls="'false'"
      :load-tiles-while-animating="true"
      :load-tiles-while-interacting="true"
      data-projection="EPSG:4326"
      style="height: 100%;flex:1"
    >
      <vl-view :zoom.sync="zoom" :center.sync="geolocPosition" :rotation.sync="rotation"></vl-view>

      <vl-geoloc @update:position="geolocPosition = $event">
        <template slot-scope="geoloc">
          <vl-feature v-if="geoloc.position" id="position-feature">
            <vl-geom-point :coordinates="geoloc.position"></vl-geom-point>
            <vl-style-box>
              <vl-style-icon
                src="https://vuelayers.github.io/_media/marker.png"
                :scale="0.4"
                :anchor="[0.5, 1]"
              ></vl-style-icon>
            </vl-style-box>
          </vl-feature>
        </template>
      </vl-geoloc>

      <vl-layer-tile id="osm">
        <!-- <vl-source-xyz url="https://tiles.wmflabs.org/osm-no-labels/{z}/{x}/{y}.png"></vl-source-xyz>-->
        <vl-source-xyz url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"></vl-source-xyz>
      </vl-layer-tile>
    </vl-map>

    <div class="bottom-actions">
      <button @click="apriAttraversamento">
        <img src="../assets/iconattraversamento.svg" />Attraversamento
      </button>
      <button @click="apriScuola">
        <img src="../assets/iconscuola.svg" />Hotzone: Scuola
      </button>
    </div>

    <div :class="popupClass">
      <div v-if="popup=='attraversamento'">
        <img src="../assets/iconattraversamento.svg" />
        <h3>Attraversamento pedonale</h3>
        <p>Stai segnalando che in questa posizione è presente un attraversamento pedonale potenzialmente pericoloso.</p>

        <button>Si, confermo</button>
        <a @click="chiudiPopup">No, annulla</a>
      </div>

      <div v-if="popup=='scuola'">
        <img src="../assets/iconscuola.svg" />
        <h3>Hotzone: Scuola nelle vicinanze</h3>
        <p>Stai segnalando che questa è una zona a rischio perchè nelle vicinanze è presente una scuola</p>

        <button>Si, confermo</button>
        <a @click="chiudiPopup">No, annulla</a>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Segnala",
  components: {
    HeaderSegnala: () => import("@/components/headers/Segnala.vue")
  },
  methods: {
    apriAttraversamento() {
      this.popup = "attraversamento";
    },
    apriScuola() {
      this.popup = "scuola";
    },
    chiudiPopup() {
      this.popup = "null";
    }
  },
  computed: {
    popupClass: function() {
      return "popup " + this.popup;
    },
    homeClass: function() {
      return "home " + this.popup;
    }
  },
  data() {
    return {
      zoom: 16,
      center: [0, 0],
      rotation: 0,
      geolocPosition: undefined,
      popup: null
    };
  }
};
</script>

<style lang="less" scoped>
.home {
  position: relative;
}
.bottom-actions {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(235, 178, 141, 0.8);
  padding: 20px;
  flex-direction: row;
  align-items: flex-start;
  display: flex;
  overflow: auto;
  button {
    background: #fff;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);
    padding: 10px 20px;
    border-radius: 50px;
    border: none;
    font-weight: bold;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
    display: flex;
    outline: none;
    img {
      margin-right: 15px;
    }

    margin-right: 20px;
  }
}

.home:not(.null) .header-container {
  transform: translate(0, -100%);
}
.home .vl-map {
  transition: all 300ms;
}
.home:not(.null) .vl-map {
  transform: translate(0, -140px);
  pointer-events: none;
}

.header-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  background: #fff;
  min-height: 100px;
}

.popup {
  transform: translate(0, 100%);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 99;

  padding: 40px 30px;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);

  max-height: 100%;
  overflow: auto;
  transition: all 300ms;
  &:not(.null) {
    transform: translate(0, 0%);
  }

  img {
    width: 30px;
  }

  p {
    text-align: left;
    font-size: 1.1em;
    margin-bottom: 2em;
  }

  button,
  a {
    margin: auto;
    border: none;
    padding: 10px 30px;
    font-weight: 400;
    border-radius: 50px;
    min-width: 50%;
    font-size: 1.2em;
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    font-weight: bold;
    outline: none;
  }
  button {
    background: darken(#ebb28d, 5%);
    color: #fff;
  }
}
</style>